import {
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, FileText } from 'lucide-angular';
import { Resource } from '../../grading.types';
import { ImagePreviewModalComponent, PreviewItem } from '../image-preview-modal/image-preview-modal.component';

@Component({
  selector: 'app-message-attachments-preview',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, ImagePreviewModalComponent],
  templateUrl: './message-attachments-preview.component.html',
  styleUrl: './message-attachments-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageAttachmentsPreviewComponent {
  readonly resources = input<Resource[]>([]);
  readonly alignEnd = input<boolean>(false);

  protected readonly icons = {
    FileText,
  };

  protected previewItem: PreviewItem | null = null;

  protected isPdf(mimeType: string): boolean {
    return mimeType === 'application/pdf';
  }

  protected getResourceUrl(resource: Resource): string {
    return resource.signedUrl || resource.url;
  }

  protected openPreview(resource: Resource, event: Event): void {
    event.preventDefault();
    this.previewItem = {
      url: this.getResourceUrl(resource),
      fileName: resource.originalName,
      mimeType: resource.mimeType,
    };
  }

  protected closePreview(): void {
    this.previewItem = null;
  }
}
